import {register, CloudObject, defineProperty, defineRelation, Direction} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class ColumnsToDisplay extends CloudObject {
    /**
     * Creates an instance of ColumnsToDisplay.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(ColumnsToDisplay);
    }

    /**
     * @return {string}
     */
    getColumnName() {
        return this.get(ColumnsToDisplay.columnNameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeColumnName($) {
        return this.observe($, ColumnsToDisplay.columnNameProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setColumnName(transaction, instance, value) {
        transaction.update(instance, ColumnsToDisplay.columnNameProp, value);
    }
}

// Hardcoded tags
register('0190ee0446054305004b', ColumnsToDisplay);
ColumnsToDisplay.columnNameProp = defineProperty('0190ee0488f951ad58e2');
ColumnsToDisplay.inverse_userSettingscolumnsToDisplayRel = defineRelation('0190ee04c3937ca1df22', Direction.ORIGIN);
